var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import classNames from "classnames";
import { FormattedMessage, FormattedRelativeTime, injectIntl } from "react-intl";
import FeedDataType from "../../../data/FeedDataType";
import { Link } from "react-router-dom";
import Routes from "../../../routes/RoutesConfig";
import { ApplicationContext } from "../../../ApplicationContext";
import Signals from "../../../signals/Signals";
import DeleteFeedCommand from "../../../commands/feeds/DeleteFeedCommand";
var FeedRow = /** @class */ (function (_super) {
    __extends(FeedRow, _super);
    function FeedRow(props) {
        var _this = _super.call(this, props) || this;
        _this.onRemoveFeed = _this.onRemoveFeed.bind(_this);
        return _this;
    }
    FeedRow.prototype.render = function () {
        var feedModel = this.props.feedModel;
        var session = this.context.session;
        var now = Date.now();
        var classes = classNames({
            'feed-row': true,
            "bg-white": true,
            "w-100": true,
            'mb-4': true,
            "pl-3": true,
            "pr-3": true,
            'pt-4': true,
            'pb-4': true,
        });
        var badge;
        switch (feedModel.getStatusType()) {
            case 'success':
                badge = React.createElement("span", { className: "fe fe-check-circle text-success", title: feedModel.statusMessage });
                break;
            case 'warning':
                badge = React.createElement("span", { className: "fe fe-alert-circle text-warning", title: feedModel.statusMessage });
                break;
            case 'danger':
                badge = React.createElement("span", { className: "fe fe-x-circle text-danger", title: feedModel.statusMessage });
                break;
        }
        var lastRefreshTimestamp = feedModel.lastRefreshTimestamp ? Math.floor((feedModel.lastRefreshTimestamp.getTime() - now) / 1000) : null;
        return (React.createElement("div", { style: { display: "contents" }, className: classes },
            React.createElement("div", { className: "text-center align-middle" }, badge),
            React.createElement("div", { className: "text-nowrap font-weight-bold align-middle" }, feedModel.providerName),
            React.createElement("div", { className: "text-nowrap align-middle" },
                React.createElement(FormattedMessage, { id: FeedDataType[feedModel.dataType].labelId })),
            React.createElement("div", { className: "text-nowrap text-left align-middle" }, feedModel.isEnabled && lastRefreshTimestamp ?
                React.createElement(FormattedRelativeTime, { value: lastRefreshTimestamp, updateIntervalInSeconds: 60 }) :
                '-'),
            session.user.isOwner ?
                React.createElement("div", { className: "align-middle text-nowrap" },
                    React.createElement(Link, { to: Routes.FEED_EDIT.getPath({ id: feedModel.id }) },
                        React.createElement("button", { className: "btn btn-sm btn-outline-primary" },
                            React.createElement("i", { className: "fe fe-edit-2" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "page.feeds.editfeed" }))),
                    React.createElement("button", { className: "btn btn-sm btn-outline-danger", onClick: this.onRemoveFeed, "data-id": feedModel.id },
                        React.createElement("i", { className: "fe fe-trash" }),
                        " ",
                        React.createElement(FormattedMessage, { id: "page.feeds.removefeed" }))) : null));
    };
    FeedRow.prototype.onRemoveFeed = function (event) {
        var _a = this.props, intl = _a.intl, feedModel = _a.feedModel;
        var _b = this.context, feedCollection = _b.feedCollection, session = _b.session;
        var feedId = feedModel.id;
        var feed = feedCollection.findById(feedId);
        //title, body, confirmText = 'Ok', cancelText = 'Cancel', onConfirm = null, onCancel = null
        Signals.ShowConfirmModal.dispatch(intl.formatMessage({ id: 'page.feeds.removefeed.confirm.title' }, feed), intl.formatMessage({ id: 'page.feeds.removefeed.confirm.body' }, feed), intl.formatMessage({ id: 'page.feeds.removefeed.confirm.yes' }, feed), intl.formatMessage({ id: 'page.feeds.removefeed.confirm.no' }, feed), function () {
            var command = new DeleteFeedCommand();
            command.execute(session.user.organisation, feed, feedCollection, intl);
        });
    };
    return FeedRow;
}(React.Component));
FeedRow.contextType = ApplicationContext;
export default injectIntl(FeedRow);
